import React, { forwardRef, useCallback, useImperativeHandle, useMemo, useRef, } from 'react';
import classNames from 'classnames';
import { CnPopover } from './popover';
const classPrefix = 'cn-ui-m-popover-menu';
export const CnPopoverMenu = forwardRef((props, ref) => {
    const innerRef = useRef(null);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    useImperativeHandle(ref, () => innerRef.current, []);
    const onClick = useCallback((e) => {
        const { onAction } = props;
        if (onAction) {
            onAction(e);
        }
        innerRef.current?.hide();
    }, [props.onAction]);
    const overlay = useMemo(() => {
        return (React.createElement("div", { className: `${classPrefix}-list` },
            React.createElement("div", { className: `${classPrefix}-list-inner` }, props.actions.map((action, index) => (React.createElement("a", { key: action.key ?? index, className: classNames(`${classPrefix}-item`, `${classPrefix}-plain-anchor`, action.disabled && `${classPrefix}-item-disabled`), onClick: () => {
                    if (action.disabled)
                        return;
                    onClick(action);
                    action.onClick?.();
                } },
                action.icon && (React.createElement("div", { className: `${classPrefix}-item-icon` }, action.icon)),
                React.createElement("div", { className: `${classPrefix}-item-text` }, action.text)))))));
    }, [props.actions, onClick]);
    return (React.createElement(CnPopover, { ref: innerRef, ...props, className: classNames(classPrefix, props.className), content: overlay }, props.children));
});
